import React from 'react';

export default class ErrorBoundary extends React.Component {

    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    componentDidCatch(error, info) {
      // Display fallback UI
     
      console.log("Error:-", error, info)
      this.setState({ hasError: true });
      // log the error to an error reporting service
      //  logErrorToMyService(error, info);
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return <div className="error-msg">Something went wrong.</div>;
      }
      return this.props.children;
    }
  }